import Vue from 'vue';
import { api } from "../../services/Api.js";

export function add_pdf({ state }, payload ){

    // adding token
    payload.token=state.appSettings.token
  
    // get active school
    var school = state.user_schools.find(school => school.active === 1);
    
    

    // make api call
    return api
    .post(school,"add_pdf.php",payload)
    .then( result =>{ 
      Vue.$toaster.toast("language.pdf_upload_success");
      return result;
    })
    .catch( error => {
      Vue.$toaster.toast("store: add_pdf: "+error);
      return error;
    })

   
    
  }